module.exports = __webpack_public_path__ + "static/media/logo.8ff2c2e2.png";